import {
  GET_SALESTYPE,
  GET_SALESTYPE_SUCCESS,
  GET_SALESTYPE_FAIL,
  DELETE_SALESTYPE,
  DELETE_SALESTYPE_SUCCESS,
  DELETE_SALESTYPE_FAIL,
  UPDATE_SALESTYPE,
  UPDATE_SALESTYPE_SUCCESS,
  UPDATE_SALESTYPE_FAIL,
  ADD_NEW_SALESTYPE,
  ADD_SALESTYPE_SUCCESS,
  ADD_SALESTYPE_FAIL,
  SALESTYPE_LOADING,
  SALESTYPE_RESET,
} from "./actionType";

export const resetSalesTypeState = (actionType) => ({
  type: SALESTYPE_RESET,
  payload: { actionType },
});

export const getSalesTypeSuccess = (actionType, data) => ({
  type: GET_SALESTYPE_SUCCESS,
  payload: { actionType, data },
});

export const getSalesTypeFail = (actionType, error) => ({
  type: GET_SALESTYPE_FAIL,
  payload: { actionType, error },
});

export const getSalesType = data => ({
  type: GET_SALESTYPE,
  payload: data,
});

export const getSalesTypeLoading = () => ({
  type: SALESTYPE_LOADING
});

export const deleteSalesType = data => ({
  type: DELETE_SALESTYPE,
  payload: data,
});

export const deleteSalesTypeSuccess = data => ({
  type: DELETE_SALESTYPE_SUCCESS,
  payload: data,
});

export const deleteSalesTypeFail = error => ({
  type: DELETE_SALESTYPE_FAIL,
  payload: error,
});

export const updateSalesType = data => ({
  type: UPDATE_SALESTYPE,
  payload: data,
});

export const updateSalesTypeFail = error => ({
  type: UPDATE_SALESTYPE_FAIL,
  payload: error,
});

export const updateSalesTypeSuccess = data => ({
  type: UPDATE_SALESTYPE_SUCCESS,
  payload: data,
});

export const addNewSalesType = data => ({
  type: ADD_NEW_SALESTYPE,
  payload: data,
});

export const addSalesTypeSuccess = data => ({
  type: ADD_SALESTYPE_SUCCESS,
  payload: data,
});

export const addSalesTypeFail = error => ({
  type: ADD_SALESTYPE_FAIL,
  payload: error,
});